<template>
  <div v-if="show" class="modalOverlay" @click.self="closeModal">

    <div class="modalCard">

      <header class="modalHeader">
        <h3>{{ title }}</h3>
        <button class="modalClose" @click="closeModal">×</button>
      </header>

      <div class="modalBody">

        <input
          type="file"
          @change="handleFileUpload"
          accept=".xlsx"
        />

        <div style="margin-top:15px;">
          <button
            class="loginbtn primaryBtn"
            @click="uploadDataToDatabase"
            :disabled="!sheetOneData.length && !sheetTwoData.length"
          >
            Subir Datos
          </button>
        </div>

        <p v-if="sheetOneData.length || sheetTwoData.length" style="margin-top:15px;">
          {{ sheetOneData.length }} registros cargados en la primera hoja.<br />
          {{ sheetTwoData.length }} registros cargados en la segunda hoja.
        </p>

      </div>

    </div>

  </div>
</template>

<script>
import * as XLSX from "xlsx";

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: "Título del Modal",
    },
  },

  data() {
    return {
      sheetOneData: [],
      sheetTwoData: [],
    };
  },

  methods: {

    closeModal() {
      this.$emit("close");
    },

    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();

      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        if (workbook.SheetNames.length >= 2) {

          const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
          const secondSheet = workbook.Sheets[workbook.SheetNames[1]];

          this.sheetOneData = XLSX.utils.sheet_to_json(firstSheet);
          this.sheetTwoData = XLSX.utils.sheet_to_json(secondSheet);

          console.log("Datos de la primera hoja:", this.sheetOneData);
          console.log("Datos de la segunda hoja:", this.sheetTwoData);

        } else {
          alert("El archivo debe contener al menos dos hojas.");
        }
      };

      reader.readAsArrayBuffer(file);
    },

    uploadDataToDatabase() {
      if (this.sheetOneData.length || this.sheetTwoData.length) {

        console.log("Subiendo los datos de la primera hoja:", this.sheetOneData);
        console.log("Subiendo los datos de la segunda hoja:", this.sheetTwoData);

        alert("Datos subidos con éxito.");
      }
    },

  },
};
</script>